// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6edb0bd6","453":"5442bdf1"}[chunkId] + ".chunk.js";
};